// Уровни слова: на каждый уровень своя пара { phrase, photo }.
// word.levels = { A1: {phrase, photo}, A2: {...}, ... }
// Старые слова (без levels) мигрируют на чтении: их photo/phrase
// воспринимаются как пара на уровне word.lvl (или A1). Нейтрал => {}.

export const LEVEL_ORDER = ['A1', 'A2', 'B1', 'B2'];

export function getWordLevels(word) {
  if (!word) return {};
  if (word.levels && typeof word.levels === 'object') return word.levels;
  const legacyPhoto = word.photo || null;
  const legacyPhrase = (typeof word.phrase === 'string' && word.phrase.trim()) ? word.phrase : '';
  if (!legacyPhoto && !legacyPhrase) return {};
  const lvl = LEVEL_ORDER.includes(word.lvl) ? word.lvl : 'A1';
  return { [lvl]: { phrase: legacyPhrase, photo: legacyPhoto } };
}

export function getActiveLevels(word) {
  const map = getWordLevels(word);
  return LEVEL_ORDER.filter((lv) => {
    const slot = map[lv];
    return slot && (slot.photo || (slot.phrase && String(slot.phrase).trim()));
  });
}

export function getWordDisplayLevel(word) {
  const active = getActiveLevels(word);
  return active.length ? active[0] : null;
}

export function getPhraseForLevel(word, level) {
  const slot = getWordLevels(word)[level];
  return slot && typeof slot.phrase === 'string' ? slot.phrase : '';
}

export function getPhotoForLevel(word, level) {
  const map = getWordLevels(word);
  if (map[level] && map[level].photo) return map[level].photo;
  const idx = LEVEL_ORDER.indexOf(level);
  // Наследуем фото только ВНИЗ — с младших уровней (A1 базовый, вверх не заимствуем).
  for (let i = idx - 1; i >= 0; i -= 1) {
    const s = map[LEVEL_ORDER[i]];
    if (s && s.photo) return s.photo;
  }
  return null;
}

// Карта уровней с миграцией старых слов (мутабельная копия).
export function buildLevels(word) {
  if (word.levels && typeof word.levels === 'object') {
    const out = {};
    Object.keys(word.levels).forEach((k) => { out[k] = { ...word.levels[k] }; });
    return out;
  }
  const out = {};
  const legacyPhoto = word.photo || null;
  const legacyPhrase = (typeof word.phrase === 'string' && word.phrase.trim()) ? word.phrase : '';
  if (legacyPhoto || legacyPhrase) {
    const lvl = LEVEL_ORDER.includes(word.lvl) ? word.lvl : 'A1';
    out[lvl] = { phrase: legacyPhrase, photo: legacyPhoto };
  }
  return out;
}

// Синхронизация зеркала word.photo/phrase под текущий уровень.
export function applyWordLevel(word, levels, currentLevel) {
  const slot = levels[currentLevel];
  const phrase = slot && typeof slot.phrase === 'string' ? slot.phrase : '';
  const photo = getPhotoForLevel({ levels }, currentLevel);
  return { ...word, levels, lvl: currentLevel, phrase, photo };
}
